import { render, staticRenderFns } from "./CustomProductPage.vue?vue&type=template&id=7d0aeb88&scoped=true"
import script from "./CustomProductPage.vue?vue&type=script&lang=js"
export * from "./CustomProductPage.vue?vue&type=script&lang=js"
import style0 from "./CustomProductPage.vue?vue&type=style&index=0&id=7d0aeb88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0aeb88",
  null
  
)

export default component.exports